export default {
  isLoading: (state) => state.isLoading,
  isButtonLoading: (state) => state.isButtonLoading,
  errors: (state) => state.errors,
  errorFields: (state) => state.errorFields,
  isErrorModalOpened: (state) => state.isErrorModalOpened,
  isBiometricModalOpened: (state) => state.isBiometricModalOpened,
  isTermsModalOpened: (state) => state.isTermsModalOpened,
  modalBackToRoute: (state) => state.modalBackToRoute,
  hasNotification: (state) => state.hasNotification,
  isWebView: (state) => state.isWebView,
  modalTitle: (state) => state.modalTitle,
  isQrScanClosed: (state) => state.isQrScanClosed,
  qrPointData: (state) => state.qrPointData,
  backRouteName: (state) => state.backRouteName,
  isLinkageView: (state) => state.isLinkageView,
  qrRouteData: (state) => state.qrRouteData,
  notClickOutside: (state) => state.notClickOutside,
  isPayCameraOpened: (state) => state.isPayCameraOpened,
};
